import cloneDeep from 'lodash/cloneDeep';
// import _ from 'lodash';

import React, { useContext, useState, useEffect, useRef } from 'react'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import { useStyles } from "../hooks/useStyles";
import { useUtils } from "../hooks/useUtils";
import { usePhrasing, useLookups } from "../hooks/useSkuUtils";
import Table from 'react-bootstrap/Table';
import { useTranslation } from "react-i18next";
import { ShopperContext } from '../context/shopper';
import * as Constants from '../constants';
import CircleShoppers from './CircleShoppers';
import HeadingBuilder from '../components/HeadingBuilder';
import CircleSubscriptionForm from '../components/CircleSubscriptionForm';
// import Trips from './Trips';
import styles from '../css/trTdFirstChild.module.css';

const Circle = ({argsId = null}) => {
  const { signedIn, shopper, circles, circleShoppers,
          plans, setClientReferenceId,
        } = useContext(ShopperContext);

  const handleHide = (e) => {
    // Setting a value for clientReferenceId lights up the Buy Button;
    // Unsetting it makes Buy Button disappear.
    setClientReferenceId('');
    setFormFlag(false);
  }

  const [formFlag, setFormFlag] = useState(false);
  const showTheForm = () => { setFormFlag(true)  }

  const [subsRowsFlag, setSubsRowsFlag] = useState(false);
  const showTheSubsRows = () => { setSubsRowsFlag(true)  }
  const hideTheSubsRows = () => { setSubsRowsFlag(false) }

  const {id} = useParams();
  console.log('Circle.js id: ', id)
  const { is_shopper_a_circle_admin, toMmmDdYyyy, getTimeInSeconds,
    formatCentsToDollars,
   } = useUtils();

  const { getAnyRefundTippyContent,
    } = usePhrasing();

  const { lookup_plan_name, lookup_tz_label } = useLookups();

  const { tableShow, tableData } = useStyles();
  const { t } = useTranslation();

  const navigate = useNavigate();
  const topOfPageRef = useRef(null);

  const [searchParams] = useSearchParams();
  const timeInvitedShopper =
    searchParams.get(Constants.INVITE_TIME_QUERY_LABEL + '0' ) || 1;
  const timeInvitedLeader =
    searchParams.get(Constants.INVITE_TIME_QUERY_LABEL + '2' ) || 1;

  const topOfCShoppersRef = useRef(null);
  const topOfCInvitesRef  = useRef(null);
  useEffect(() => {
    if (signedIn) {
      // It's possible we are here via the 'navigate(-1)' logic in BackButton:
      // http://localhost:4000/circles/0192a07b-2f27-7664-945e-a04ccf6d5c43
      // And yet we may have recently deleted that same circle such that this
      // url will fail by virtue of navigating using an invalid 'id'.
      // It would be nice if we could check for a valid url while setting up the
      // BackButton, but React seems ornery about showing the history stack.
      // @react-navigation/native might help, but it's not installed.
      // So, check that the 'id' param is for a valid circle.

      // Another possibility is we land here after issuing an invitation.
      // The url will have a query parameter based on the flavor of invitation.
      // If this useEffect notices that the query url was created less than
      // five seconds ago it will shift focus to the relevant part of the page.
      const circle = circles.find((c) =>  c.id === id ) || {};
      const currTimeInSeconds = getTimeInSeconds();

      if (currTimeInSeconds - timeInvitedShopper < 5) {
        topOfCShoppersRef.current.focus();
      }
      else if (currTimeInSeconds - timeInvitedLeader < 5) {
        topOfCInvitesRef.current.focus();
      }
      else if (circle.hasOwnProperty('id')) {
        topOfPageRef.current.focus();
      } else {
        navigate('/circles');
      }
    }
  }, [signedIn, topOfPageRef, circles, id, navigate,
    getTimeInSeconds,
    timeInvitedShopper, topOfCShoppersRef,
    timeInvitedLeader, topOfCInvitesRef,
  ]);

  // This logic from Trip.js (see comments there.)
  if (circles.length === 0) {
    // 230427 getting this warning:
    // react_devtools_backend.js:2655 Warning: Cannot update a component (`BrowserRouter`) while rendering a different component (`Circle`). To locate the bad setState() call inside `Circle`, follow the stack trace as
    // So, will disable the navigate for now and put message to console.log
    console.log('Note: getting "circles.length" === 0')
    //navigate('/circles/')
    // This is progress. At least something comprehensible happens upon pressing
    // a browser reload icon.
  }

  console.log("circle plans", plans)

 if (signedIn) {
  console.log('Circle.js circles-orig: ', circles)
  const the_circles = cloneDeep(circles)  // TODO: I bet cloneDeep is unnecessary
  console.log('Circle.js circles-copy: ', the_circles)

  // load "circle" with the circle that matches the id param from url
  const circle = the_circles.find((c) => {
    console.log('find circle: ', c)
    console.log('find circle.id: ', c.id)
    console.log('find circle boolean: ', c.id == id)
    return c.id == id  // TODO: get warning for '==', but '===' fails - quiesce?
  }) || {} ;

  console.log('find circle2: ', circle)

  // We should have only gotten to this component by a valid link. But there is
  // also the case of a shopper removing themself from a circle via its (this)
  // Circle detail page. Upon re-rendering, that id no longer matches a circle
  // in the shopper's updated list of circles as saved in state. That causes
  // the 'circleIsFalse' check here to navigate to a list of shopper's circles
  // rather than persist in showing the detail page of a circle the shopper is
  // no longer a member of.
  // Also possible: someone types 'http://circles/1887' at the browser.
  // In that case, 'circle' will have no value.
  const circleIsFalse = Object.is(circle,null) || !circle.hasOwnProperty('id');
  console.log({circleIsFalse});
  if (circleIsFalse) {
    // looks safe to go to '/circles' - for a new user with no circles, /circles
    // looks mostly empty with a header of: Circles for: <shopper identifier>
    navigate('/circles');
    // TODO: need fix for this warning: react_devtools_backend.js:2655 Warning:
    // Cannot update a component (`BrowserRouter`) while rendering a different
    // component (`Circle`).
    // Maybe just live with this since it's a warning, not an error?
    return (<></>)
  }

  const if_shopper_is_circle_admin = is_shopper_a_circle_admin({
    cShoppers: circleShoppers, circle_id: circle.id, shopper_id: shopper.id
  });

  const if_shopper_is_circle_leader =  circle.leader_id === shopper.id;
// admin_count: null
// billee_id: 6
// city: null
// country: "US"
// county: null
// postal_code: null
// detail: null
// id: 9
// identifier: "x3"
// img_url: null
// label: "x4"
// leader_id: 6
// plan: {id: 1, identifier: 'free00', label: 'Free plan - testing, 220819', detail: null, max_shoppers: null, …}

  const circle_invitations = [...circle.open_invites]
  console.log("circle_invitations", circle_invitations)

  const circle_accepted_invitations = [...circle.accepted_invites]
  console.log("circle_accepted_invitations", circle_accepted_invitations)

  // find plan object of circle
  const plan = plans.find((p) => {
    return p.id == circle.plan_id
  }) || {};
  console.log("plan, circle.plan_id", plan, circle.plan_id)

  const handlePortalClick = async () => {
    try {
      const response = await fetch('/billing/session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customerId: shopper.stripe_customer_id,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      window.location.href = data.url; // Redirect to the portal URL

    } catch (error) {
      console.error('Error creating customer portal session:', error);
    }
  };

  const symbologyText =
    circle.symbology === 'upca'
      ? t('circle.symbology.optionValue0')
      : t('circle.symbology.optionValue1');

  const planManageButtonText =
    subsRowsFlag
      ? t('circle.plan.subscriptionButtonLabelToHide')
      : t('circle.plan.subscriptionButtonLabelToShow')

  const planManageButtonTippyContent =
    subsRowsFlag
      ? t('circle.plan.hideSubscriptionButtonTippyContent', {
          subscription_renews: t('subscription.currentPeriodEnd.label'),
          manage_billing: t('subscription.openStripePortal.buttonLabel')
        })
      : t('circle.plan.manageSubscriptionButtonTippyContent')

  const inviteLeaderDeleteCircleHeading =
    t('circleDeleteForm.formPart.triggerLinkLabel', {
      invite_new_leader:
        circle.shopper_count > 1
          ? t('circleDeleteForm.formPart.inviteNewLeader')
          : ''
    })

  // present that circle's members; circle admin sees button allowing altering circle membership
  return (
    <>
      <article ref={topOfPageRef} tabIndex="-1">

      <HeadingBuilder
        Size        = 'h3'
        headingText = {t('circleId.formPart.headlineLabel')}
        value       = {circle.identifier}
        // Circle Details: oipuy
      />
      <Table responsive striped bordered hover size="sm" style={tableShow}>
        <thead>
        </thead>
        <tbody className={styles.trTdFC} style={tableData} >
          <tr>
            <td>
              {/* Shopping Circle ID */}
              {t('circle.identifier.label')}
            </td>
            <td>
              {circle.identifier}
            </td>
          </tr>
          <tr>
            <td>
              {/* Description */}
              {t('circle.label.label')}
            </td>
            <td>
              {circle.label}
            </td>
          </tr>
          <tr>
            <td>
              {/* Zip Code, Country */}
              {t('circle.postal_code.label')}, {t('circle.country.label')}
            </td>
            <td>
        {circle.postal_code}, {t('circle.country.optionValue' + circle.country)}
            </td>
          </tr>
          <tr>
            <td>
              {/* Time Zone */}
              {t('circle.time_zone.label')}
            </td>
            <td>
              {lookup_tz_label({time_zone: circle.time_zone})}
              {/* 'circle.time_zone' is a Rails zone name, not prose. */}
            </td>
          </tr>
          <tr>
            <td>
              {/* Barcode Length */}
              {t('circle.symbology.label')}
            </td>
            <td>
              {symbologyText}
            </td>
          </tr>
          <tr>
            <td>
              <HeadingBuilder
                containerType  = 'container-input-label'
                headingText    = {t('circle.topoff.label')}
                  // Top Off level
                tippyAlertText = {t('circle.topoff.tippyContent', {
                  orderRange: t('ordersList.range_note_col.orderRangeLabel'),
                })}
                tippyText      = {Constants.DOT}
                // This is the level of 'top off' your Circle has agreed to...
                tippyInfoText  = {t('circle.topoff.tippyContentInfo')}
                // As an example of 'topping off': A case of soda has 24 cans..
              />
            </td>
            <td>
              {circle.topoff_level}%
            </td>
          </tr>
          <tr>
            <td>
              <HeadingBuilder
                containerType  = 'container-input-label'
                headingText    = {t('circle.share_sku_basic.label')}
                  // Share basic Sku info
                tippyAlertText = {t('circle.share_sku_basic.tippyContent', {
                  shareDetails: t('sku.shareable.label'),
                })}
                tippyText      = {Constants.DOT}
                // A 'yes' value here allows ShopWeAll to copy basic information...
                tippyInfoText  = {t('circle.share_sku_basic.tippyContentInfo', {
                  shareDetails: t('sku.shareable.label'),
                  details: t('sku.detail.label'),
                })}
              />
            </td>
            <td>
              {circle.share_sku_basic
                ? t('global.label.yes')
                : t('global.label.no')
              }
            </td>
          </tr>
          <tr>
            <td>
              {/* Plan */}
              {t('circle.plan.label')}
            </td>
            <td>
          { (if_shopper_is_circle_leader && ! circle.subscription)
            ? <>
              {formFlag
                ? <HeadingBuilder
                    containerType  = 'container-left'
                    headingText  = {t('circle.plan.hideSubscriptionButtonText')}
                    // Stop showing 'new Subscription' panel
                    buttonAction   = {handleHide}
                    goButtonText   = {Constants.GET_ICON_RT_ARROW}
                    bgroundColor   = {Constants.LIGHT_BLUE}
                    tippyText      = {Constants.DOT}
         tippyAlertText = {t('circle.plan.setupSubscriptionButtonTippyContent')}
                    // As the leader of your Circle, you are responsible for...
                  />
                : <HeadingBuilder
                    containerType  = 'container-left'
                    headingText = {t('circle.plan.setupSubscriptionButtonText')}
                    // 'Set up Subscription'
                    buttonAction   = {showTheForm}
                    goButtonText   = {Constants.GET_ICON_RT_ARROW}
                    bgroundColor   = {Constants.LIGHT_RED}
                    tippyText      = {Constants.DOT}
         tippyAlertText = {t('circle.plan.setupSubscriptionButtonTippyContent')}
                    // As the leader of your Circle, you are responsible for...
                  />
              }
              </>
            : <> { (if_shopper_is_circle_leader && circle.subscription)
              ? <HeadingBuilder
                  containerType  = 'container-left'
                  headingText    = {lookup_plan_name({plan})}
                  // e.g.: Up to 8 Shoppers, Monthly
                  // 'plan.label' is an English DB column, so build the
                  // name from 'max_shoppers' and 'period' instead.
              buttonAction = {subsRowsFlag ? hideTheSubsRows : showTheSubsRows}
                  goButtonText   = {planManageButtonText}
                    // Manage
                    // Hide Billing Rows
                  tippyText      = {Constants.DOT}
                  tippyAlertText = {planManageButtonTippyContent}
                    // Click to collapse the {{subscription_renews}} and {{manage_billing}} rows.
                    // Click to view details/terms of your subscription, change payment information at Stripe, or cancel your Subscription.
                />

              : <>{lookup_plan_name({plan})}</>
              }
              </>
          }
            </td>
          </tr>
          { (subsRowsFlag && circle.subscription)
            ?
        <>
          <tr>
            <td>
              <HeadingBuilder
                containerType = 'container-input-label'
                headingText   = {t('subscription.currentPeriodEnd.label')}
                // Subscription Renews
              tippyAlertText  = {t('subscription.currentPeriodEnd.tippyContent',
          {renewal_payment_amount:
            formatCentsToDollars({ cents: circle.subscription.stripe_amount })}
                )}
                // This is when your Subscription period expires. It will renew with an automatic payment of $19.00. 
                tippyText    = {Constants.DOT}
                // Click to open browser tab to change payment details.
              />
            </td>
            <td>
              <HeadingBuilder
                containerType  = 'container-left'
                headingText    = { toMmmDdYyyy({
                  dateString: circle.subscription.current_period_end,
                  weekday: 'short'
                })}
                // Tue, Jul 8, 2025
                bgroundColor   = {Constants.LIGHT_GREEN}
                linkUrl        =
        {`/circles/${circle.id}/subscriptions/${circle.subscription.id}/delete`}
                goButtonText   = {t('subscription.cancelButton.label')}
                // Cancel
                tippyText      = {Constants.DOT}
                tippyAlertText = {t('subscription.cancelButton.tippyContent',
                  {any_refund: getAnyRefundTippyContent({
                    planInterval: circle.subscription.stripe_interval,
                    refundAmountInteger: circle.subscription.amount_of_refund
                  })}
                )}
                // Click to cancel your subscription. This will disable Circle activity (i.e. the ability to create or search for Skus, set up new Trips, schedule orders for Trips, etc.,) until that time when you set up a new Subscription. // You won't lose data. // {{any_refund}}"
              />
            </td>
          </tr>
          <tr>
            <td>
              <HeadingBuilder
                containerType = 'container-input-label'
                headingText   = {t('subscription.openStripePortal.label')}
                // Change Payment Details
                tippyText     = {Constants.DOT}
              tippyAlertText = {t('subscription.openStripePortal.tippyContent')}
                // Click to open a new browser tab to manage payment methods and view history.
              />
            </td>
            <td>
              <HeadingBuilder
                containerType = 'container-left'
                headingText   = {'-->'}
                bgroundColor  = {Constants.LIGHT_GREEN}
                goButtonText  = {t('subscription.openStripePortal.buttonLabel')}
                // Manage billing
                buttonAction  = {handlePortalClick}
                tippyText     = {Constants.DOT}
        tippyAlertText = {t('subscription.openStripePortal.buttonTippyContent')}
                // Click to open a session with Stripe to view your invoice...
              />
            </td>
          </tr>
        </>
            : null
          }
          <tr>
            <td>
              {/* Sales Tax Rate */}
              {t('circle.tax_rate.label')}
            </td>
            <td>
              {circle.tax_rate ? <span>{`${circle.tax_rate}`}</span> : <span>0</span>}%
            </td>
          </tr>
          <tr>
            <td>
              {/* Food Sales Tax Rate */}
              {t('circle.tax_rate_food.label')}
            </td>
            <td>
              {circle.tax_rate_food ? <span>{`${circle.tax_rate_food}`}</span> : <span>0</span>}%
              {/* TODO: Below is abusive: "styling should be handled with CSS."
              Doing this to pad out content of "detail" to shift second
              column of each table row (value of attr) further to left. */}
              &emsp; &emsp; &emsp; &emsp; &emsp;
              &emsp; &emsp; &emsp; &emsp; &emsp;
              &emsp; &emsp; &emsp; &emsp; &emsp;
              &emsp; &emsp; &emsp; &emsp; &emsp;
            </td>
          </tr>
        { if_shopper_is_circle_leader
        ? <tr>
            <td>
              <HeadingBuilder
                containerType  = 'container-input-label'
                headingText    = {t('circle.resource_count.label')}
                  // Resource Counts
                tippyAlertText = {t('circle.resource_count.tippyContent')}
                tippyText      = {t('circle.resource_count.tippyContent')}
        // ... a count of all of the Skus, Trips, and OrderItems of the Circle.
              />
            </td>
            <td>
              {t('global.label.skus')}: {circle.skus_count},&nbsp;
              {t('global.label.trips')}: {circle.trips_count},&nbsp;
              {t('global.label.orders')}: {circle.order_items_count}
            </td>
          </tr>
        : null
        }
        </tbody>
      </Table>
      { formFlag
        ? <CircleSubscriptionForm
            circle = {circle}
            plan_identifier = {plan.identifier}
            doSetFormFlag = {setFormFlag}
          />
        : null
      }
      { if_shopper_is_circle_admin &&
          <HeadingBuilder
            tippyAlertText = {t('circle.editCircleButton.tippyContent')}
            tippyText      = {t('circle.editCircleButton.tippyContent')}
            linkUrl        = {`/circles/${circle.id}/edit`}
            goButtonText   = {Constants.GET_ICON_RT_ARROW}
            headingText    = {t('circle.editCircleButton.label')}
                           // Edit Circle Settings (requires admin)
          />
      }
      { if_shopper_is_circle_leader && <br/> }
      { if_shopper_is_circle_leader &&
          <HeadingBuilder
            tippyAlertText = {t('circleDeleteForm.formPart.tippyContent')}
            tippyText      = {t('circleDeleteForm.formPart.tippyContent')}
            linkUrl        = {`/circles/${circle.id}/delete`}
            goButtonText   = {Constants.GET_ICON_RT_ARROW}
            headingText    = {inviteLeaderDeleteCircleHeading}
                        // Invite New Leader / Delete Circle (requires 'leader')
                        // or
                        // Delete Circle (requires 'leader')
          />
      }
      { if_shopper_is_circle_admin ? <br/> : null }

      <Table responsive>
        <thead>
        </thead>
        <tbody>
          <tr>
            <td>
              <HeadingBuilder
                containerType  = 'oneline-container-right'
                headingText    = {t('circle.circleSkusButton.label')}
                linkUrl        = {`/circle/skus/${circle.id}`}
                tippyAlertText = {t('circle.circleSkusButton.tippyContent')}
                tippyText      = {t('circle.circleSkusButton.tippyContent')}
                               // Circle's Skus
              />
            </td>
            <td>
              <HeadingBuilder
                containerType  = 'container-left'
                headingText    = {t('circle.circleTripsButton.label')}
                linkUrl        = {`/circle/trips/${circle.id}`}
                tippyAlertText = {t('circle.circleTripsButton.tippyContent')}
                tippyText      = {t('circle.circleTripsButton.tippyContent')}
                               // Circle's Trips
              />
            </td>
          </tr>
        </tbody>
      </Table>
      </article>
      <hr />
      <article ref={topOfCShoppersRef} tabIndex="-1" >
        <CircleShoppers
          circle_id={circle.id}
          circle_identifier={circle.identifier}
          circle_leader_id={circle.leader_id}
          open_invites={circle_invitations}
          accepted_invites={circle_accepted_invitations}
          topOfInvitesRef={topOfCInvitesRef}
        />
      </article>
    </>
  )
 } else {
    return (
      <HeadingBuilder
        Size = 'h3'
        headingText = {t('global.notSignedInMessage')}
        // Not Authorized - Please Sign in or Sign up
      />
    )
 }
}
export default Circle
      // <hr />
      // <div>
      //   <Trips circle_id={circle.id} circle_identifier={circle.identifier}/>
      // </div>